import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import BankAccount from 'shared/components/BankAccount';
import { Checkbox } from 'shared/io';
import { formatAmount } from 'shared/utils/currency';

import styleIdentifiers from './DebtorReactionCardHeader.module.scss';

const styles = classNames.bind(styleIdentifiers);

type Props = {
  data: any;
  selectAll: boolean;
  hasPaymentOptions: boolean;
  onChangeSelectAll: Function;
};

export default function DebtorReactionCardHeader({
  data,
  hasPaymentOptions,
  selectAll,
  onChangeSelectAll,
}: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles('debtor-reaction-card-header')}>
      <div>
        <span>
          IBAN : <BankAccount value={data?.company_data.iban || ''} />
        </span>
        <span>
          {t(i18nKeys.INVOICE.DUE_AMOUNT)} : {formatAmount(data?.totalRemainingBalance)}
        </span>
      </div>
      {hasPaymentOptions && (
        <div>
          <Checkbox
            noMargin
            label={t(selectAll ? 'FORM.DESELECT_ALL' : 'FORM.SELECT_ALL')}
            name=""
            onChange={onChangeSelectAll}
            checked={selectAll}
          />
        </div>
      )}
    </div>
  );
}
